import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageTransition from '../../components/PageTransition';
import SafeIcon from '../../common/SafeIcon';
import { FiCheckCircle, FiShield } from 'react-icons/fi';

const BillingPlaceholder = () => {
  const navigate = useNavigate();

  return (
    <PageTransition className="flex items-center justify-center bg-rutabaga-bg min-h-screen p-4 font-sans">
      <div className="w-full max-w-2xl p-12 bg-white rounded-lg shadow-xl border border-gray-100">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-rutabaga-pink/5 text-rutabaga-pink rounded-full text-xs font-black uppercase tracking-widest mb-8">
            <SafeIcon icon={FiShield} />
            Secure Lab Activation
          </div>
          <h1 className="text-4xl font-black text-rutabaga-dark tracking-tight">Activate Your Lab</h1>
          <p className="text-gray-500 mt-3 font-medium text-lg">Choose the infrastructure that powers your research.</p>
        </div>

        <div className="bg-rutabaga-dark p-10 rounded-lg text-white shadow-2xl relative overflow-hidden group">
          <div className="absolute -top-10 -right-10 p-4 opacity-5 group-hover:scale-110 transition-transform duration-700">
            <SafeIcon icon={FiShield} className="text-[15rem]" />
          </div>
          
          <div className="relative z-10">
            <div className="flex justify-between items-start mb-10">
              <div>
                <h3 className="text-3xl font-black">Pro Researcher</h3>
                <p className="text-gray-400 text-sm mt-2 font-medium">Full access to all research modules</p>
              </div>
              <div className="text-right">
                <span className="text-5xl font-black">$0</span>
                <span className="text-gray-500 block text-[10px] font-black uppercase tracking-widest mt-2">14-Day Free Trial</span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-y-4 gap-x-8 mb-10">
              {['Unlimited Projects', 'All Interview Modules', 'Sentiment Analysis AI', 'Team Collaboration', 'Export Data', 'Priority Support'].map((feature) => (
                <div key={feature} className="flex items-center gap-3 text-sm font-bold">
                  <SafeIcon icon={FiCheckCircle} className="text-rutabaga-pink text-lg" />
                  <span className="text-gray-200">{feature}</span>
                </div>
              ))}
            </div>

            <button 
              onClick={() => navigate('/projects')}
              className="w-full bg-rutabaga-pink text-white py-5 rounded-2xl font-black hover:bg-rutabaga-pink-hover transition-all shadow-xl shadow-rutabaga-pink/20 text-xl"
            >
              Initialize My Lab
            </button>
            <p className="text-center text-gray-500 text-[10px] mt-6 font-black uppercase tracking-widest">
              Early Access Program • No credit card required today
            </p>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default BillingPlaceholder;